import React from 'react';
import BackBtn from 'components/shared/BackBtn';
import { ReactComponent as IconSuccess } from 'images/success.svg';
import { ReactComponent as IconInfo2 } from 'images/info2.svg';
import { ReactComponent as IconEmail } from 'images/email-sent.svg';
import { ReactComponent as IconInfo } from 'images/info-circle-o.svg';
import { ReactComponent as IconSorry } from 'images/baby.svg';
import { ReactComponent as IconDelete } from 'images/delete.svg';
import clsx from 'clsx';
import Modal from 'components/shared/modals/Modal';
import styles from './MessageModal.module.scss';

const INFO = 'info'
const INFO2 = 'info2'
const SUCCESS = 'success'
const EMAIL = 'email'
const SORRY = 'sorry'
const ERROR = 'error'
const DELETE = 'delete'
type INFOT = typeof INFO
type INFO2T = typeof INFO2
type SUCCESST = typeof SUCCESS
type EMAILT = typeof EMAIL
type DELETET = typeof DELETE
type SORRYT = typeof SORRY
type ERRORT = typeof ERROR
type STATUS = EMAILT | SUCCESST | INFOT | INFO2T | SORRYT | ERRORT | DELETET

type SuccessProps = {
  status: STATUS,
  title: string,
  message: React.ReactNode,
  onClick: () => void,
  onBack?: () => void,
  buttons?: React.ReactNode[],
  small?: boolean,
  medium?: boolean,
  creatorSuccess?: boolean,
  showCloseBtn?: boolean,
}

const icons = {
  success: <IconSuccess className={styles.icon} />,
  email: <IconEmail className={styles.icon} />,
  info: <IconInfo className={styles.icon} />,
  info2: <IconInfo2 className={styles.icon} />,
  delete: <IconDelete width={43} height={43} className={styles.icon} />,
  sorry: <IconSorry className={styles.icon} />,
  error: <IconInfo className={styles.icon} />,
}

function MessageModal({
  message,
  title,
  status,
  onClick,
  onBack,
  buttons,
  small,
  medium,
  creatorSuccess,
  showCloseBtn,
}: SuccessProps) {
  return (
    <Modal
      className={clsx(
        styles.messageModal,
        small && styles.messageModalSmall,
        medium && styles.messageModalMedium,
        creatorSuccess && styles.messageModalCreatorSuccess,
      )}
      onClose={onClick}
      zIndex={1000}
      isOpen
      showCloseBtn={showCloseBtn}
    >
      {onBack ? (
        <BackBtn
          className={styles.btnBack}
          onClick={onBack}
        />
      ) : null}
      {icons[status] || null}
      <div className={styles.status}>{title}</div>
      <div className={styles.msg}>{message}</div>
      {buttons?.length ? (
        <div className={styles.btns}>
          {buttons.map((btn) => (btn))}
        </div>
      ) : null}
    </Modal>
  )
}

export default MessageModal
